import currency from '@/libs/currency';
import store from '@/store/index'
import axios from "axios"
import * as dayjs from 'dayjs'
const isBetween = require("dayjs/plugin/isBetween");
export function ProcesarXML(archivoxml,estado,IdLibroCompra){
 
  const Estado = estado;
       let patharchivoXML = (window.URL || window.webkitURL).createObjectURL(archivoxml);
       
       let xhttp = new XMLHttpRequest();
       xhttp.onreadystatechange = async function() {
           if (xhttp.readyState == 4 && xhttp.status == 200) {
             // Validamos el estado
             if(Estado==='Recibida'){
               //Procesamos facturas Emitidas
               await procesarItemEmitidos(xhttp)
             }
           }
       };
       //FACTURA COMBUSTIBLE 
       xhttp.open("GET",patharchivoXML, true);
       xhttp.send();

       //Función para procesar los xml
       async function procesarItemEmitidos(xml){
           let xmlDoc = xml.responseXML;

           let dteReceptor = xmlDoc.getElementsByTagName("dte:Emisor")[0];
           
           let Persona = dteReceptor.getAttributeNode("NombreEmisor").nodeValue;
           const Nit = dteReceptor.getAttributeNode("NITEmisor").nodeValue;
           const regimen = dteReceptor.getAttributeNode("AfiliacionIVA").nodeValue;
           let status = {msg:'OK',descripcion:'Factura Lista para procesar'}

           if(regimen==='PEQ'){
              status.msg = 'ERROR'
              status.descripcion='Factura de pequeño Contribuyente'
           }

           let dteFac = xmlDoc.getElementsByTagName("dte:NumeroAutorizacion")[0];
           const Serie = dteFac.getAttributeNode("Serie").nodeValue;
           const NumeroFactura = dteFac.getAttributeNode("Numero").nodeValue;
       
           const IdProveedor = await getProveedor(Nit,Persona);
           //Obtenemos Fecha de Emision
           let datosgenerales=xmlDoc.getElementsByTagName("dte:DatosGenerales")[0];
           const FechaFactura=datosgenerales.getAttributeNode("FechaHoraEmision").nodeValue;

           
           
 
            let FelGenerado={
                IdLibroCompra:IdLibroCompra,
                FechaFactura:FechaFactura,
                NumeroFactura:NumeroFactura,
                Serie:Serie,
                IdProveedor:IdProveedor,
                Proveedor:Persona,
                Nit:Nit,
                regimen:regimen,
                TotalSinIVA:0,
                IVA:0,
                total:0,
                Servicio:0,
                status,
            }
            let cantidadImpuestos = xmlDoc.getElementsByTagName("dte:TotalImpuesto").length;
           // let TotalPetroleo = xmlDoc.getElementsByTagName("dte:TotalImpuesto")[1].getAttribute("TotalMontoImpuesto") //xmlDoc.getAttributeNode("NombreCorto")[0]
      
           if(cantidadImpuestos==0){
              FelGenerado.status.msg = 'ERROR'
              FelGenerado.status.descripcion = 'No se encontró ningun Impuestos en este documento'
           }
            if(cantidadImpuestos>1){
              let TotalFactura = currency((xmlDoc.getElementsByTagName("dte:GranTotal")[0].childNodes[0].nodeValue),2).value;
              let TotalPetroleo = currency((xmlDoc.getElementsByTagName("dte:TotalImpuesto")[1].getAttribute("TotalMontoImpuesto")),2).value;
              FelGenerado.Servicio=TotalFactura-TotalPetroleo

              FelGenerado.TotalSinIVA=currency((FelGenerado.Servicio/1.12),2).value;
              FelGenerado.IVA = currency((FelGenerado.Servicio/1.12)*0.12,2).value;
              
            }
            
            if(cantidadImpuestos==1){
                FelGenerado.total=currency((xmlDoc.getElementsByTagName("dte:GranTotal")[0].childNodes[0].nodeValue),2).value;
                FelGenerado.TotalSinIVA=currency((FelGenerado.total/1.12),2).value;
                FelGenerado.IVA = currency((FelGenerado.total/1.12)*0.12,2).value;
            }    
            
        if(FelGenerado.status.msg === 'OK')validarFechaFactura(FelGenerado)                          
        if(FelGenerado.status.msg === 'OK')buscarFactura(FelGenerado)                          
        store.dispatch("setFacturas",FelGenerado)      
       }

       //funcion para buscar el nuevo proveedor
      async function getProveedor(nit,proveedor){
        const persona=store.getters.buscarProveedor(nit)
        let idpersona = 0;
        let headeraxios={
          headers:{'auth-user':store.getters.getToken}
        }
        if(persona){
          idpersona = persona.IdProveedor
        }else{
          await axios.get(`${store.getters.getUrlApi}/personas/${nit}`,headeraxios).then(res=>{        
            if(res.data.length>0){
              idpersona = res.data[0].IdProveedor
            }else{ idpersona = false}
          }).catch(err=>{console.log(err)})       
        }

        if(!idpersona){
         await axios.post(`${store.getters.getUrlApi}/personas`,{Nit:nit,Proveedor:proveedor,Tipo:'Proveedor'},headeraxios).then(res=>{
            //Traemos listado de los proveedor
            idpersona = res.data[0].insertId
            store.dispatch("setTopProveedores")
          }).catch(err=>{
            console.error(err)
          })
        }
        return idpersona
      }

      //Validaciones
    function validarFechaFactura(itemfel) {
      //Validar que la fecha de la factura este dentro del trimestre
      //VALIDAR QUE LAS FECHAS SEAN VALIDAS
      dayjs.extend(isBetween);
      const periodo = dayjs(store.getters.getCompra.Periodo).add(
        1,
        "day"
      );
      //PERIODO: 2020-10-01T04:0

      // A periodo Le quitamos un dia para que el rango este entre el ultimo dia del mes anterior
      //Por ejempo periodo =  01/04/2019 quitandole un dia quedaria 31/03/2019
      let FechaInicio = dayjs(periodo)
        .subtract(3, "months")
        .endOf("months")
        .format("YYYY-MM-DD");
      //Al ultimo día del periodo le sumamos un dia más 31/03/2019 y 01/05/2019
      const FechaFin = periodo.add(1, "month").format("YYYY-MM-DD"); //.add(1,"day").format('YYYY-MM-DD');
      const FechaActual = dayjs(itemfel.FechaFactura).format(
        "YYYY-MM-DD"
      );
      let FechaValida = dayjs(FechaActual).isBetween(FechaInicio, FechaFin);

      if (!FechaValida){
        itemfel.status.msg = 'ERROR'
        itemfel.status.descripcion = 'La fecha de la factura no esta dentro del periodo permitido por SAT'
      }
      else{
        itemfel.status = {msg:'OK',descripcion:'Factura Lista para procesar'}
      }
      
    }

    async function buscarFactura(itemfel){
      const {data} = await store.dispatch("buscarFactura",itemfel)
      console.log(data)
      if(data[0]){
        console.log(data[0])
        const mes = dayjs(data[0].Periodo).add(1,'day').format('MMMM')
        itemfel.status.msg = 'ERROR'
        itemfel.status.descripcion = `La Factura ya fue procesada en el libro de compras de ${mes}, Revisar Porfavor`
      }
    }
      
}



